import React from 'react';
import ReactDOM from 'react-dom/client';
import {
    Navigate,
    Route,
    BrowserRouter as Router,
    Routes,
} from 'react-router-dom';
import App from './App';
import Documents from './Documents';

import 'smartsuite-ui/dist/smartsuite-ui.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Router>
        <Routes>
            <Route path="/" element={<App />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    </Router>
);
